export default __webpack_public_path__ + "static/media/q9_step2_6.874aa37a.png";